import { Injectable } from '@angular/core';
import { StockDirection } from '../../enums/stock-direction.enum';
import { ApiService } from '../api/api.service';
import { INutrientLivestockPlanTransfer } from './nutrient-livestock-plan-transfer.model';

@Injectable()
export class NutrientLivestockPlanTransferService {
  constructor(private apiService: ApiService) {}

  saveLivestockPlanTransfers(
    livestockPlanTransfers: INutrientLivestockPlanTransfer[],
    direction: StockDirection,
    planId: number
  ): Promise<any> {
    return this.apiService.post(
      `v1/nutrient-livestock-plan-transfers/${direction}/${planId}`,
      livestockPlanTransfers
    );
  }
}
